type MobileNavigator = Navigator & {
  userAgentData?: {
    mobile?: boolean
  }
}

export function isInIosBrowser(): boolean {
  return !!(
    navigator.userAgent.match(/iPhone/i) ||
    navigator.userAgent.match(/iPad/i) ||
    navigator.userAgent.match(/iPod/i)
  )
}

export function isInAndroidBrowser(): boolean {
  return !!navigator.userAgent.match(/Android/i)
}

function isInIpadDesktopBrowser(deviceNavigator: Navigator): boolean {
  return deviceNavigator.platform === 'MacIntel' && deviceNavigator.maxTouchPoints > 1
}

export function isInMobileDevice(): boolean {
  const deviceNavigator = navigator as MobileNavigator

  if (typeof deviceNavigator.userAgentData?.mobile === 'boolean')
    return deviceNavigator.userAgentData.mobile

  return (
    isInIosBrowser() ||
    isInAndroidBrowser() ||
    isInIpadDesktopBrowser(deviceNavigator) ||
    !!navigator.userAgent.match(/Mobile/i)
  )
}
